/* Small presentation bits shared by both M4 pages — React ports of the mockup
   zoneBadge / bluePill / agreementCell helpers (mini-pill + tag tokens). */
import React from 'react'
import PropTypes from 'prop-types'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import WarningAmberIcon from '@mui/icons-material/WarningAmberOutlined'
import {agreementShort, agreementLabel} from '../components'
import {ZONE_NAMES} from './zoneEngine'

/* zoneBadge(z): Zone 3 = blue, Zone 4 = amber, Zone 5 = red, Zone 1/2 = green,
   null = "No zone" red. Matches the mockup colour ramp exactly. */
export function ZoneBadge({zone}) {
  if (zone == null) return <span className='mini-pill mp-red'>No zone</span>
  if (zone === 3)
    return (
      <span className='mini-pill mp-blue' title={ZONE_NAMES[zone]}>
        Zone 3
      </span>
    )
  const cls = zone === 5 ? 'mp-red' : zone === 4 ? 'mp-amber' : 'mp-green'
  return (
    <span className={'mini-pill ' + cls} title={ZONE_NAMES[zone]}>
      Zone {zone}
    </span>
  )
}
ZoneBadge.propTypes = {zone: PropTypes.number}

export function BluePill({label, style}) {
  return (
    <span className='mini-pill mp-blue' style={style}>
      {label}
    </span>
  )
}
BluePill.propTypes = {label: PropTypes.node, style: PropTypes.object}

/* agreementCell(id): friendly linked-agreement tag, or the shared Unlinked pill. */
export function AgreementCell({id}) {
  if (!id)
    return (
      <span className='mini-pill mp-amber'>
        <WarningAmberIcon style={{width: 11, height: 11, verticalAlign: '-2px'}} /> Unlinked
      </span>
    )
  return (
    <span className='tag' title={agreementLabel(id)}>
      <DescriptionOutlinedIcon style={{width: 12, height: 12}} /> {agreementShort(id)}
    </span>
  )
}
AgreementCell.propTypes = {id: PropTypes.string}
